import { useMemo } from 'react'

import ModalIllustrativeIcon from '@design-system/modalillustrativeicon'

import { useLocale } from 'context/LocaleContext'
import { useUserData } from 'context/RegistrationContext'

import { useGtmTrack } from 'modules/gtm'

import { liferayParser } from 'utils/liferayParser'

interface ModalProps {
  liferayFields: {
    showIcon?: boolean
    showDescription?: boolean
    showTextBox?: boolean
    showPrimaryButton?: boolean
    showSecondaryButton?: boolean
    showDisclaimer?: boolean
    title?: string
    description?: string
    disclaimer?: string
    textBoxText?: string
    primaryButtonLabel?: string
    secondaryButtonLabel?: string
    iconName?: string
    primaryButtonHref?: string
  }
}

export const Disclaimer = ({ html }: { html: string }) => {
  return <span id="test" dangerouslySetInnerHTML={{ __html: html }}></span>
}

export default function ModalIllustrativeIconRegisterWrapper({
  liferayFields
}: ModalProps) {
  const { isEmailExistsModalOpen, closeEmailExistsModal } = useUserData()
  const { dataLayerPush } = useGtmTrack()

  const { primaryButtonHref, ...liferayFieldsContent } = useMemo(
    () => liferayParser(liferayFields),
    [liferayFields]
  )

  const handlePrimaryButton = () => {
    dataLayerPush({
      event: 'cta_login',
      section: 'Creacion de cuenta',
      sub_section: 'modal',
      element: 'ingresar en mi cuenta',
      action: 'click'
    })
    closeEmailExistsModal()
    if (primaryButtonHref) window.location.href = primaryButtonHref
  }

  const disclaimer = liferayFieldsContent.disclaimer || ''

  const { brand } = useLocale()

  return (
    <ModalIllustrativeIcon
      className={'disclaimerText'}
      isOpen={isEmailExistsModalOpen}
      onClose={closeEmailExistsModal}
      onClickPrimaryButton={handlePrimaryButton}
      onClickSecondaryButton={closeEmailExistsModal}
      secondaryButton={{
        appearance: 'outline'
      }}
      bgSecondary={true}
      project={brand}
      {...liferayFieldsContent}
      disclaimer={<Disclaimer html={disclaimer} />}
    />
  )
}
